import { render } from "./tradeCoin.vue?vue&type=template&id=6e77a032"
import script from "./tradeCoin.vue?vue&type=script&lang=js"
export * from "./tradeCoin.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__